import {
  CalculateMatrixResponse,
  MatrixForwardCurveSeriesModel,
  MatrixGraphPointModel,
  MatrixTermResultModel,
  MatrixYearPriceSeriesModel,
} from '../../../../Generated/Mark-It-View-Api';

// The generated API types mark all properties as optional.
// These strict versions reflect what the API actually returns (all fields populated).
// Use these in component props and internal logic.

export interface MatrixPrice {
  quoteDate: string;
  contractDate: string;
  price: number;
}

export interface MatrixTermResult {
  season: string;
  weightedDeciles: MatrixResult[];
  innerDeciles: MatrixResult[];
  outerDeciles: MatrixResult[];
  innerMean: number;
  outerMean: number;
  weightedMean: number;
  innerPrices: MatrixPrice[];
  outerPrices: MatrixPrice[];
  innerPriceCount: number;
  outerPriceCount: number;
}

export interface MatrixGraphPoint {
  calculationDate: string;
  terms: MatrixTermResult[];
}

export interface MatrixYearPriceSeries {
  year: number;
  term: string;
  dailyPrices: MatrixYearPriceDaily[];
}

export interface MatrixYearPriceDaily {
  date: string;
  price: number | null;
}

export interface MatrixForwardCurveSeries {
  term: string;
  quoteDate: string;
  prices: MatrixForwardCurvePoint[];
}

export interface MatrixForwardCurvePoint {
  contractMonth: number;
  contractYear: number;
  price: number;
}

export interface MatrixResult {
  rank: number;
  value: number;
}

// Narrowing helpers — cast API response arrays to strict types at the boundary.
export function narrowResults(results: MatrixTermResultModel[] | null | undefined): MatrixTermResult[] {
  return (results ?? []) as unknown as MatrixTermResult[];
}

export function narrowGraphPoints(points: MatrixGraphPointModel[] | null | undefined): MatrixGraphPoint[] {
  return (points ?? []) as unknown as MatrixGraphPoint[];
}

export function narrowYearPriceSeries(series: MatrixYearPriceSeriesModel[] | null | undefined): MatrixYearPriceSeries[] {
  return (series ?? []) as unknown as MatrixYearPriceSeries[];
}

export function narrowForwardCurveSeries(series: MatrixForwardCurveSeriesModel[] | null | undefined): MatrixForwardCurveSeries[] {
  return (series ?? []) as unknown as MatrixForwardCurveSeries[];
}
